export default __webpack_public_path__ + "static/media/ai_face_detectionActive.565456a4.svg";